import { render, staticRenderFns } from "./AppCalendar.vue?vue&type=template&id=c88d0d18&scoped=true&lang=pug&"
import script from "./AppCalendar.vue?vue&type=script&lang=js&"
export * from "./AppCalendar.vue?vue&type=script&lang=js&"
import style0 from "./AppCalendar.vue?vue&type=style&index=0&id=c88d0d18&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88d0d18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c88d0d18')) {
      api.createRecord('c88d0d18', component.options)
    } else {
      api.reload('c88d0d18', component.options)
    }
    module.hot.accept("./AppCalendar.vue?vue&type=template&id=c88d0d18&scoped=true&lang=pug&", function () {
      api.rerender('c88d0d18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UI/AppCalendar.vue"
export default component.exports